import React, { useEffect, useState } from 'react';
import { classList } from '../../../utils/string.ts';
import { Icon } from '../icon/icon.tsx';
import { safeWindow } from '../../../utils/window.ts';
import { throttle } from '../../../utils/throttle.ts';

export type ToTopButtonProps = {
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
};

/**
 * We use the same visual back button in many places.
 */
export const ToTopButton: React.FunctionComponent<ToTopButtonProps> = props => {
  const { className, onClick } = props;
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    function handleScroll() {
      const win = safeWindow();

      if (!win) {
        return;
      }

      const { top } = win.document.body.getBoundingClientRect();

      setShowButton(top < 0);
    }

    safeWindow()?.addEventListener('scroll', throttle(handleScroll, 250));
  });

  return (
    <a
      onClick={event => {
        if (onClick) {
          onClick(event);
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }}
      className={classList(
        'bg-sk-grey-0 text-sk-red-500 focus-visible:bg-sk-grey-200 hover:bg-sk-grey-200 fixed right-6 bottom-32 z-(--z-index-backdrop) inline-block h-8 w-8 scale-150 cursor-pointer content-center justify-center rounded-full text-center shadow transition-opacity',
        showButton ? 'opacity-100' : 'opacity-0',
        className
      )}
    >
      <Icon
        name="arrow-right"
        className="-mb-2 block -rotate-90 transform align-bottom text-2xl leading-none"
      />
    </a>
  );
};
